// src/components/common/SiteVersion.jsx
import { CHANGELOG_CONFIG } from "../../data/changeLog";
import { cn } from "../../lib/utils";

export default function SiteVersion({ className = "" }) {
  const latest = CHANGELOG_CONFIG[CHANGELOG_CONFIG.length - 1];
  if (!latest) return null;
  return (
    <span className={cn("text-xs text-primary-500/50", className)}>
      v{latest.version}
    </span>
  );
}

// Footer.jsx や Sidebar.jsx など
// import SiteVersion from "../common/SiteVersion";
// <SiteVersion />               // → v0.1.0
// <SiteVersion className="ml-2" />  // クラス追加も可